import request from 'helpers/request';
import api from 'config';

export const SettlementTradingList = (params) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/trading`,
    params: params
  });

export const SettlementTradingInfoDetail = (taxUnitSeq) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/trading/${taxUnitSeq}`
  });

export const SettlementMetaInfoDetail = (companyId, params) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/company/${companyId}`,
    params: params
  });

export const SettlementTaxInvoice = (taxUnitSeq, params) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/taxInvoice/${taxUnitSeq}`,
    params: params
  });

export const SettlementBankDeposit = (taxUnitSeq, params) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/bankDeposit/${taxUnitSeq}`,
    params: params
  });

export const SettlementProgressStatus = (taxUnitSeq, params) =>
  request({
    url: api.config.companyAPI + `/settlement/v1/status/${taxUnitSeq}`,
    params: params
  });
